import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";

export function initAnimations() {
    initMainScreenAnimations();
    initBodyAnimations();

    function initMainScreenAnimations(){
        const $mainImage = $('.main-screen-image');
        const $headerContainer = $('.header-container');
        const $flatInfoWrapper = $('.flat-info-wrapper');

        $mainImage.addClass('animate');

        setTimeout(() => {
            $headerContainer.addClass('animate');
            $flatInfoWrapper.addClass('animate');
        }, 400)

        /*const headerTl =  gsap.timeline()

        headerTl.from($mainImage, {
            opacity: 0,
            duration: 1,
        })

        headerTl.from($header, {
            opacity: 0,
            translateY: -150,
            duration: 0.6,
        })

        headerTl.from($flatInfo, {
            opacity: 0,
            translateY: -150,
            duration: 0.6,
        });*/
    }

    function initBodyAnimations(){
        const gsapMatchMedia = gsap.matchMedia();
        const gsapSections = $('[data-gsap-section]');

        gsapSections.each(function () {
            const timeLine = gsap.timeline({
                paused: true
            });

            const gsapSectionAnimatedItems = gsap.utils.toArray($(this).find('[data-gsap-from-top]'));
            const gsapSectionSettings = $(this).data('gsap-section');

            gsapMatchMedia.add("(min-width: 767px)", () => {
                timeLine
                    .from(gsapSectionAnimatedItems, {
                        /*opacity: 0,*/
                        translateY: -150,
                        duration: 10,
                        stagger: 3,
                    });

                ScrollTrigger.create(
                    {
                        animation: timeLine,
                        trigger: $(this),
                        start: gsapSectionSettings.start,
                        end: gsapSectionSettings.end,
                        scrub: 10,
                        once: true
                    }
                );
            });

            /*gsapMatchMedia.add("(max-width: 767px)", () => {
                timeLine.from(gsapSectionAnimatedItems, {
                    opacity: 0,
                    duration: 10,
                    translateY: 150,
                    stagger: 0.5,
                });

                ScrollTrigger.create({
                    animation: timeLine,
                    trigger: $(this),
                    start: 'top 80%',
                    end: 'top 80%',
                    scrub: 4,
                });
            });*/
        });
    }
}